// 当前为调试模式或者开发模式
export const env =
	uni.getSystemInfoSync().platform === "devtools" ||
	process.env.NODE_ENV === "development";

// 默认配置
const def = {
	env, // 环境

	// 全局请求配置
	tokenName: 'apptoken', // 请求 token 字段名
	reqType: 'json', // 请求类型 form
	reqMethod: 'post', // 请求方式 get
	reqJiaMi: false, // 请求是否加密（不使用时可以将`common/request-lib.js`里的`导入加密模块`两行代码注释，减小打包体积）
	reqLoading: true, // 请求是否显示loading弹框
	reqSync: true, // 请求是否使用同步方式
}

// 生产环境 打包时
const dep = {
	apiUrlTest: window.location.protocol + "//" + window.location.host + "/web",
	apiUrl: "/prod-api/api"
};

// 开发环境 开发时
const dev = {
	// apiUrlTest: window.location.protocol + "//" + window.location.host + "/web",
	// // apiUrl: "/prod-api/api/v1",
	// apiUrl: "/prod-api/api/v1",
	apiUrlTest: "/web",
	apiUrl: "/api"
}

let config = def;

// 开发环境
if (env) {
	config = Object.assign({}, def, dev);
} else {
	config = Object.assign({}, def, dep);
}

export default config
